import {memo} from 'react';
import {Head} from '@shopify/hydrogen';

export const ContactFormEmbed = memo(() => {
  return (
    <div className={'w-full -mt-16'}>
      <Head>
        <script
          defer
          id="gorgias-contact-bundle"
          type="text/javascript"
          src="https://skiessentials-help-center.gorgias.help/api/contact-form-loader.js?source=https://skiessentials-help-center.gorgias.help/en-US/embed/contact"
        />
        <link
          rel="stylesheet"
          href="https://skiessentials-help-center.gorgias.help/api/contact-form-loader.css"
        />
      </Head>
      <div id="gorgias-contact-form-wrapper">
        <div id="gorgias-contact-form-loader"></div>
      </div>
    </div>
  );
});
